import { useEffect, useRef, useState } from "react";
import Form from "./Form";
import SuccessSend from "./SuccessSend";

export default function FormWrapper({ onClose }) {
  const [isOpen, setIsOpen] = useState(true);
  const [toastType, setToastType] = useState(null);
  const timerRef = useRef(null);
  const prevOverflow = useRef("");

  useEffect(() => {
    if (isOpen) {
      prevOverflow.current = document.body.style.overflow;
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = prevOverflow.current || "";
    }

    return () => {
      document.body.style.overflow = prevOverflow.current || "";
    };
  }, [isOpen]);

  const handleClose = () => {
    setIsOpen(false);
    onClose?.();
  };

  const handleFinish = (ok) => {
    setToastType(ok ? "success" : "error");
    setIsOpen(false);

    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      setToastType(null);
      onClose?.();
    }, 2000);
  };

  return (
    <>
      {isOpen && (
        <div className="formWrapper" role="dialog" aria-modal="true">
          <div className="formWrapper__overlay" onClick={handleClose} />

          <div className="formWrapper__form" role="document">
            <div className="formWrapper__form__header">
              <h3>Open a new request</h3>
              <button type="button" onClick={handleClose} aria-label="Close">
                <img src="/images/cross.svg" alt="" />
              </button>
            </div>

            <Form onFinish={handleFinish} />
          </div>
        </div>
      )}

      {toastType && (
        <div className="successToast" role="status" aria-live="polite">
          <SuccessSend type={toastType} />
        </div>
      )}
    </>
  );
}
